// extracted by mini-css-extract-plugin
module.exports = {"CustomerListItemContainer":"style_CustomerListItemContainer__2cWJA","namePhoneContainer":"style_namePhoneContainer__1iCLf"};